<div class="bgf-page">
  <div class="bgf-head">
    <h1 class="stk-page-title">BGFox termékek</h1>
    <div class="stk-page-sub">
      Csökkentett üzemmód: a BGFox termékekről nem vezetünk készletet, nincs hiány-, gyártási és beszerzési cél.
      A rendelések ugyanúgy bejönnek. A készlet itt csak az utolsó ismert, tájékoztató érték.
    </div>
  </div>

  <div class="bgf-toolbar">
    <div class="bgf-search">
      <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><circle cx="11" cy="11" r="6.5"></circle><line x1="16" y1="16" x2="21" y2="21"></line></svg>
      <input type="text" [ngModel]="search" (ngModelChange)="onSearch($event)" placeholder="Keresés játék, termék, komponens vagy SKU szerint…">
    </div>
    <div class="bgf-count" *ngIf="!loading && !loadFailed">
      {{ games.length }} játék · {{ productCount }} termék · {{ componentCount }} különálló komponens
    </div>
  </div>

  <div class="bgf-state" *ngIf="loading && !games.length">Betöltés…</div>
  <div class="bgf-state bgf-state--error" *ngIf="loadFailed">
    Nem sikerült betölteni a listát. <button type="button" class="bgf-link" (click)="load()">Újra</button>
  </div>
  <div class="bgf-state" *ngIf="!loading && !loadFailed && !games.length">
    {{ search.trim() ? 'Nincs találat.' : 'Nincs BGFox termék.' }}
  </div>

  <section class="bgf-game" *ngFor="let game of games; trackBy: trackGame">
    <button type="button" class="bgf-game__head" (click)="toggleGame(game)" [attr.aria-expanded]="isGameOpen(game)">
      <span class="bgf-chev" [class.bgf-chev--open]="isGameOpen(game)">
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><polyline points="9,6 15,12 9,18"></polyline></svg>
      </span>
      <span class="bgf-game__name">{{ game.game }}</span>
      <span class="bgf-game__meta">
        {{ game.products.length }} termék<ng-container *ngIf="game.components.length"> · {{ game.components.length }} komponens</ng-container>
      </span>
    </button>

    <div class="bgf-game__body" *ngIf="isGameOpen(game)">
      <ng-container *ngFor="let product of game.products; trackBy: trackItem">
        <div class="bgf-row" [class.bgf-row--clickable]="product.children?.length" (click)="toggleProduct(product)">
          <div class="bgf-img">
            <img *ngIf="product.image_file" [appFetchComponentImage]="product.image_file" alt="">
          </div>
          <div class="bgf-row__copy">
            <div class="bgf-row__name">{{ product.name }}</div>
            <div class="bgf-row__meta">
              <span class="bgf-sku">{{ product.sku }}</span>
              <span *ngIf="product.product_group">{{ product.product_group }}</span>
            </div>
          </div>
          <div class="bgf-row__bom">
            <span *ngIf="product.children?.length; else noBom" class="bgf-bom-toggle">
              {{ product.children!.length }} komponens
              <span class="bgf-chev bgf-chev--sm" [class.bgf-chev--open]="isProductOpen(product)">
                <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><polyline points="6,9 12,15 18,9"></polyline></svg>
              </span>
            </span>
            <ng-template #noBom><span class="bgf-muted">{{ kindLabel(product.kind) }}</span></ng-template>
          </div>
          <div class="bgf-row__stock" title="Utolsó ismert készlet — nem vezetjük">{{ stockLabel(product.stock) }}</div>
        </div>

        <div class="bgf-bom" *ngIf="isProductOpen(product)">
          <div class="bgf-bom__row" *ngFor="let child of product.children; trackBy: trackItem">
            <div class="bgf-img bgf-img--sm">
              <img *ngIf="child.image_file" [appFetchComponentImage]="child.image_file" alt="">
            </div>
            <div class="bgf-row__copy">
              <div class="bgf-row__name">{{ child.name || 'Ismeretlen komponens' }}</div>
              <div class="bgf-row__meta">
                <span class="bgf-sku">{{ child.sku }}</span>
                <span *ngIf="child.kind">{{ kindLabel(child.kind) }}</span>
              </div>
            </div>
            <div class="bgf-bom__qty">{{ child.quantity }} ×</div>
            <div class="bgf-row__stock">{{ stockLabel(child.stock) }}</div>
          </div>
        </div>
      </ng-container>

      <ng-container *ngIf="game.components.length">
        <div class="bgf-sub">Egyéb komponensek</div>
        <div class="bgf-row" *ngFor="let item of game.components; trackBy: trackItem">
          <div class="bgf-img bgf-img--sm">
            <img *ngIf="item.image_file" [appFetchComponentImage]="item.image_file" alt="">
          </div>
          <div class="bgf-row__copy">
            <div class="bgf-row__name">{{ item.name }}</div>
            <div class="bgf-row__meta">
              <span class="bgf-sku">{{ item.sku }}</span>
              <span *ngIf="item.product_group">{{ item.product_group }}</span>
            </div>
          </div>
          <div class="bgf-row__bom"><span class="bgf-muted">{{ kindLabel(item.kind) }}</span></div>
          <div class="bgf-row__stock">{{ stockLabel(item.stock) }}</div>
        </div>
      </ng-container>
    </div>
  </section>
</div>
